const isExtensionValid = (item, allowedExts) => {
  const path = item.name.split('.');
  const extension = `.${path.at(-1)}`;

  return allowedExts.includes(extension.toUpperCase());
};

export default isExtensionValid;
